/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useState } from "react";
import Avatar from "react-avatar";
import { Link, useNavigate } from "react-router-dom";
import PlanUnsubscribe from "../modules/settings/files/listCompomponents/PlanUnsubscribe"; // ✅ import your component
import { useParams } from "react-router-dom";



interface HeaderProps {
  mainSearch: string;
  setMainSearch: (value: string) => void;
  clearSearch: () => void;
  clickMainSearch: (e: React.MouseEvent<HTMLSpanElement>) => Promise<void>;
  handleIconClick: () => void;
  isVideoVisible: boolean;
  planName?: { name: string };
  chefStatus?: boolean;
  handleChefStatusChange: () => void;
  showNotification: () => void;
  profiledata?: { profile?: string; name?: string };
  logoutFunction: () => void;
  handleClick: React.MouseEventHandler<HTMLButtonElement>;
  isLeftBarActive: boolean;
  handleMenuBackdropClick: () => void;
}

const HeaderMenu: React.FC<HeaderProps> = ({
  mainSearch,
  setMainSearch,
  clearSearch,
  clickMainSearch,
  handleIconClick,
  isVideoVisible,
  planName,
  chefStatus,
  handleChefStatusChange,
  showNotification,
  profiledata,
  logoutFunction,
  handleClick,
  isLeftBarActive,
  handleMenuBackdropClick,
}) => {
  const navigate = useNavigate();
  const [showUnsubscribe, setShowUnsubscribe] = useState(false); // ✅ state added
  
const { id } = useParams();
const chefId = id;
console.log("Chef ID:", id);
  return (
    <div>
      <section className="head row top-header align-items-center py-2 px-3">
        <div className="col-7 col-md-7 d-flex align-items-center">
          <div className="nav-brand d-md-none">
            <img
              className="img-fluid me-1"
              src="/assets/images/logo.svg"
              alt="Frayo"
              style={{ width: "80px", height: "auto" }}
            />
          </div>
        </div>

        <div className="col-5 col-md-5 d-flex align-items-center justify-content-end gap-3 flex-wrap">
          {/* YouTube Icon */}
          <div
            className="d-none d-md-block"
            onClick={handleIconClick}
            style={{ cursor: "pointer" }}
          >
            <i
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Walk through video."
              className="material-symbols-outlined"
              style={{
                color: "red",
                fontSize: "36px",
                width: "36px",
                height: "36px",
              }}
            >
              youtube_activity
            </i>
          </div>

          {/* Plan Badge */}
          <div
            style={{
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
            onClick={() => navigate("/subscription")}
          >
            <span
              className="badge bg-success"
              style={{
                fontSize: "0.86rem",
                padding: "10px 16px",
                borderRadius: "20px",
              }}
            >
              {planName?.name || "Starter Chef"}
            </span>
          </div>

          {/* Online/Offline Toggle */}
          <div
            className="form-check form-switch live me-3"
            style={{ minWidth: "120px", gap: "4px" }}
          >
            <input
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="An Online/Offline status indicator for chefs."
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={chefStatus || false}
              onChange={handleChefStatusChange}
            />
            <label className="yes mb-0 small">Online</label>
            <label className="no mb-0 small">Offline</label>
          </div>

          {/* Notifications */}
          <a
            href="#"
            onClick={showNotification}
            className="notify-ico d-flex align-items-center"
          >
            <span className="material-symbols-outlined">notifications</span>
          </a>

          {/* Profile Dropdown */}
          <div className="dropdown profile-dd">
            <button
              className="btn dropdown-toggle d-flex align-items-center"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <Avatar
                src={profiledata?.profile}
                name={profiledata?.name}
                maxInitials={1}
                size="25"
                round
                color="#607458"
                fgColor="#fff"
              />
              <p className="px-2 mb-0">{profiledata?.name}</p>
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <Link className="dropdown-item" to="/settings">
                  Settings
                </Link>
              </li>

              <li>
                <a
                  className="dropdown-item cursorPointer"
                  onClick={logoutFunction}
                >
                  Logout
                </a>
              </li>

              {/* ✅ Fixed Unsubscription Button */}
<li className="mobile-only">
  <button
    type="button"
    className="dropdown-item"
    onClick={() => navigate(`/subscription/unsubscribe/${chefId}`)}
  >
    Manage Subscription
  </button>
</li>



            </ul>
          </div>

          {/* Mobile Menu Button */}
          <button className="btn menu-mobile d-md-none" onClick={handleClick}>
            <span>&nbsp;</span>
          </button>

          {/* Backdrop */}
          <div
            className={`menu-backdrop ${isLeftBarActive ? "active" : ""}`}
            onClick={handleMenuBackdropClick}
          ></div>
        </div>
      </section>

      {/* YouTube Modal */}
      {isVideoVisible && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <iframe
            style={{
              position: "relative",
              width: "560px",
              height: "315px",
            }}
            src="https://www.youtube.com/embed/GjOv7A3bsRk?autoplay=1"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
          <button
            onClick={handleIconClick}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "red",
              color: "white",
              border: "none",
              borderRadius: "5px",
              padding: "5px 10px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      )}

      {/*   Unsubscribe Modal */}
      {showUnsubscribe && (
        <PlanUnsubscribe showFinalModal={true} />
      )}
    </div>
  );
};

export default HeaderMenu;